import React, { useRef, useState } from 'react';
import { Button, Form} from 'react-bootstrap';
import call from './call-img.jpg';
import "./App.css"

const QuestionForm = () => {
    const url = 'https://www.like-it.sk/ws/kontakt/index.php?do=add';

    const [showContact, setShowContact] = useState(false);

    const aktReferral = 'cseu-konkretne-skolenie';

    const questionRef = useRef('');
    const contactRef = useRef('');

    const handleCss = () => {
        let form = document.getElementById("form");
        form.classList.add("form-true");
    };


    var formular = {
        meno: "",
        mail: contactRef.current.value,
        mobil: "",
        poziadavka: questionRef.current.value,
        ref: aktReferral
    }

    function naplnUdajeFormularu() {
        formular.meno = "(detail kurzu lit)";
        formular.mail = contactRef.current.value;
        formular.mobil= "";
        formular.poziadavka= questionRef.current.value;
        formular.ref = document.getElementById("lit-frm-ref").innerHTML;
        console.log("ref:", formular.ref);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        naplnUdajeFormularu();

        fetch(url, {
            method: 'POST',
            body: JSON.stringify(formular), //JSON.stringify(formularPokus), //JSON.stringify(formular),
            headers: {
                // (takto spracuje $_POST PHP, ale potom treba https://stackoverflow.com/questions/35325370/how-do-i-post-a-x-www-form-urlencoded-request-using-fetch)
                // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Content-Type': 'application/json; charset=UTF-8',
            }
        }).then((response) => {
            alert("Správa bola odoslaná. Budeme Vás kontaktovať do 72 hodín.");
            return response.json();
        }).then((jsonData) => {
            console.log(jsonData);
        }).catch((error) => {
            alert("Správu žiaľ nebolo možné odoslať. Kontaktujte nás prosím emailom alebo telefonicky.");
            console.error('Error:', error);
        });

        console.log(formular);
    };

    return (
        <Form onSubmit={handleSubmit}>
            <div className={"justify-content-center d-flex"}>
            <div className="mt-5 lit-bg-dark rounded-top p-2 pt-4 w-75 shadow">

                <div className={"row"}>
                    <div className={"col-lg-2 p-lg-1 justify-content-center d-flex"}>
                        <img className={"rounded-circle lit-img-rozmer ml-lg-5 shadow lit-border"} src={call} alt={"otazka"}/>
                    </div>
                    <div className={"col-lg-9"}>
                        <div className={"mb-2 ml-2 text-white"}>
                            <h5 className="bi bi-question-circle-fill">Máte otázku ku kurzu?</h5>
                        </div>
                        <div>
                            <Form.Control required className={"shadow"} type="text" name="question" ref={questionRef} autocomplete="off" onInput={handleCss} placeholder="Napíšte vašu otázku" />
                        </div>
                    </div>
                </div>
            </div>
            </div>

                <div id={"form"} className={"form animation"} >
                    <div className={"justify-content-center d-flex"}>
                        <div className="lit-bg-dark rounded-bottom p-2 w-75 shadow pb-3">
                            <div className={"row"}>
                                <div className={"col-lg-2"}></div>
                                <div className={"col-lg-7 p-lg-0 pl-lg-3 mr-lg-4"}>
                                    <Form.Control required type="text" className={"shadow mb-2"} name="contact" autocomplete="off" ref={contactRef} placeholder="Telefón alebo email" />
                                </div>
                                <div className={"col-lg-2 p-lg-0"}>
                                    <Button variant="success" className={"btn btn-info shadow btn-back"} type="submit">Odoslať</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </Form>
    );
};

export default QuestionForm;